import {Component} from '@angular/core';

@Component({
    selector: 'app-loader-spin',
    templateUrl: './loader-spin.component.html',
    styleUrls: ['./loader-spin.component.less']
})
export class LoaderSpinComponent {
    delay = 500;
}
